// API Service for Jiva Nadi
// Simple axios-based HTTP client

import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://jivanadi.com/backend/api.php';

// Configure axios defaults
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

// Low-level API function
export async function apiGet(endpoint, params = {}) {
  try {
    const url = `/${endpoint}`;

    const response = await axios.get(url, { params });
    return response.data;
  } catch (error) {
    console.error(`API Error for ${endpoint}:`, error);
    throw error;
  }
}

export async function apiPost(endpoint, data = {}) {
  try {
    const url = `/${endpoint}`;

    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error(`API Error for ${endpoint}:`, error);
    throw error;
  }
}

// Test API connectivity
export async function testConnection() {
  try {
    const result = await apiGet('settings', { limit: 1 });
    return { success: true, data: result };
  } catch (error) {
    return { success: false, error: error.message };
  }
}